import React, { useContext } from "react";
import NavBar from "../../Components/NavBar";
import { useAnimateOnScroll } from "../../Hooks/useAnimationScroll";
import PrivacyTermsContent from "../../Components/PrivacyTermsContent/PrivacyTermsContent";
import { secureDataConst } from "../../constants/PrivacyTermsConst";
import { LanguageContext } from "../../Hooks/langugaeContext";
import { useTranslation } from "../../Hooks/useTranslation";

function Secure() {
  const translations = useTranslation();
  const { language } = useContext(LanguageContext);
  useAnimateOnScroll();
  return (
    <div>
      <NavBar onlyWhiteBg={true} />
      <PrivacyTermsContent
        title={translations.securePageTitle}
        content={secureDataConst[language]}
      />
    </div>
  );
}

export default Secure;
